// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__qeK3k","link":"footer_link__34aZ7"};